const en = {
  // Header
  address: "Address",
  home: "Home",
  about: "About",
  schemes: "Schemes",
  howItWorks: "How it Works",
  login: "Login",

  // Banner
  bannerTitle: "Risk & Welfare Fund Management System",
  bannerTagline: "",
  bannerSubtitle:
    "A unified digital platform for managing Risk & Welfare Scheme for Co-operative Banks/Societies",
  readMore: "Read more",

  // About service cards
  riskFundBeneficiaries: "Risk fund beneficiaries",
  riskFundBeneficiariesDesc:
    "Apply for dead, accident or disability claims and track status",
  applyForClaim: "Apply for Claim",
  societiesAndBanks: "Societies and Banks",
  societiesAndBanksDesc:
    "Registered institutions managing Risk & Welfare Schemes",
  registerSociety: "Register Society",

  // About section
  aboutUsLabel: "About Us",
  aboutRWFMS: "About RWFMS",
  aboutDesc:
    "The Risk & Welfare Fund Management System (RWFMS) enables both beneficiaries and cooperative institutions to efficiently access and manage Risk & welfare schemes.",
  digitalProcessing: "Digital Processing",
  digitalProcessingDesc:
    "Eliminating paperwork with automated end-to-end digital Application workflows.",
  transparentGovernance: "Transparent Governance",
  transparentGovernanceDesc:
    "Real-time tracking and comprehensive public audits for every transaction.",
  swiftDisbursement: "Swift Disbursement",
  swiftDisbursementDesc:
    "Ensure timely disbursement of funds to beneficiaries without any intermediate delays.",

  // Schemes section
  schemesCovered: "Schemes Covered",
  riskFundSchemes: "Risk Fund Schemes",
  riskFundSchemesDesc:
    "The Risk & welfare Fund Management system transitions manual processes into a secure, paperless digital environment for the Kerala Co-operative Development and Welfare Fund Board. Our goal is to ensure that beneficiaries receive their due support without delay and maximum transparency.",
  deathClaimSupport: "Death claim Support",
  deathClaimDesc:
    "The Risk & welfare Fund Management system transitions manual processes into a secure, paperless digital environment for the Kerala Co-operative Development and Welfare Fund Board. Our goal is to ensure that beneficiaries receive their due support without delay and maximum transparency.",
  treatmentClaimSupport: "Treatment Claim Support",
  treatmentClaimDesc:
    "Financial aid for members affected by serious, life-threatening illness.",

  // Welfare section
  welfareFundSchemes: "Welfare Fund Schemes",
  welfareFundSchemesDesc:
"The Welfare Fund Scheme is designed to rehabilitate and strengthen financially weaker co-operative societies. To avail loan assistance in case of financial loss and access the services offered by the Kerala Co-operative Development and Welfare Fund Board (KCDWFB), societies must enroll in the scheme and obtain membership. Through this portal, societies can take new membership, activate existing membership, remit annual contributions, and complete renewal payments seamlessly. This ensures continued eligibility to receive financial support from the Board whenever required.",
  societyEnrollment: "Society Enrollment",
  societyEnrollmentDesc:
    "Streamlined process for societies to join welfare initiatives of Kerala Co-operative Development and Welfare Fund Board.",
  annualRenewal: "Annual Renewal",
  annualRenewalDesc:
    "Automated reminders and simple payment gateways for yearly membership maintenance.",

  // How it Works
  howItWorksLabel: "How it Works",
  easySteps: "Easy 4 steps of the work process",
  register: "Register",
  registerDesc: "Signup as a Beneficiary or Society",
  submitClaim: "Submit Claim",
  submitClaimDesc: "Upload necessary documents online",
  verification: "Verification",
  verificationDesc: "Verification at the society, department & board Level",
  disbursement: "Disbursement",
  disbursementDesc: "Funds transferred directly to Bank",
};

export default en;
